import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMapPin: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="map-pin, location"><path fillRule="evenodd" clipRule="evenodd" d="M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.29 19.0635 14.4327 17.8969 16.2215C16.7265 18.016 15.2865 19.5125 14.19 20.5255C12.9407 21.6797 11.0593 21.6797 9.81002 20.5255C8.71352 19.5125 7.27353 18.016 6.10314 16.2215C4.93646 14.4327 4 12.29 4 10ZM8.875 10C8.875 8.27411 10.2741 6.875 12 6.875C13.7259 6.875 15.125 8.27411 15.125 10C15.125 11.7259 13.7259 13.125 12 13.125C10.2741 13.125 8.875 11.7259 8.875 10Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMapPin;
